<template>
	<div class="site-backups-list-wrapper">
		<div>
			<div class="row mb-5">
				<div class="col-md-8">
					<p>
						<a href="https://help.bigscoots.com/useful-tools-and-tips/wpo-redirect-regex-examples" target="_blank">
							Please check out our examples before adding any rules!
						</a>
					</p>
				</div>
				<div class="col-md-4 pull-right">
					<div class="custom-file">
						<input type="file" class="custom-file-input" id="customFile" ref="file" @change="importRedirects($event)" :disabled="loading">
						<label v-if="this.file" class="custom-file-label" for="customFile">{{this.file.name}}</label>
						<label v-else class="custom-file-label" for="customFile">Choose file for import (.txt)</label>
					</div>
				</div>
			</div>
			<redirect-create :loading="loading" :domain="domain" v-on:store="store" v-on:clear="redirect = {}"></redirect-create>
			<redirect-items :redirects="redirects" :itemChanged="itemChanged" :domain="domain"  v-on:remove="remove"  v-on:update="update"></redirect-items>
		</div>
	</div>
</template>

<script>
	import swal from "sweetalert2";
	import _ from "lodash";
	import {db} from "@/firebase/init";
	import uplParse from "url-parse";
	import refreshToken from "../../../mixins/refreshTokenMixin";
	import RedirectCreate from "./RedirectCreate";
	import RedirectItems from "./RedirectItems";

	export default {
		name: "RedirectList",
		mixins: [refreshToken],
		props: {
			account: {
				type: Object,
				required: true
			},
			envType: {
				type: String,
				required: true
			}
		},
		components: {
			RedirectCreate,
			RedirectItems
		},
		data: function () {
			return {
				domain: '',
				file: null,
				redirects: [],
				loading: false,
				itemChanged: false
			}
		},
		computed: {
			accounts() {
				return this.$store.getters["hosting/accounts"];
			},
			clientID() {
				return this.$store.getters.getCustomerID;
			},
			userToken() {
				return this.$store.getters.getUserToken;
			},
			user() {
				return this.$store.getters.user;
			},
			requestUserId(){
				return this.$store.getters.requestUserId;
			},
			asyncDone() {
				return this.$store.getters["async/state"];
			}
		},
		watch: {
			account: function (value) {
        let redirects = [];
        if (this.envType === 'staging') {
          this.domain = value.staging.domain;
          redirects = value.staging.redirects || [];
        } else {
          this.domain = value.domain;
          redirects = value.redirects || [];
        }
				this.redirects = _.filter(redirects, item => item.uuid);
				// this.initDataTable();
			},
			envType(value) {
				let redirects = [];
				if (value === 'staging') {
					this.domain = this.account.staging.domain;
					redirects = this.account.staging.redirects || [];
				} else {
					this.domain = this.account.domain;
					redirects = this.account.redirects || [];
				}
				this.redirects = _.filter(redirects, item => item.uuid);
				this.initDataTable();
			}
		},
		beforeMount() {
      let redirects = [];
      if (this.envType === 'staging') {
        this.domain = this.account.staging.domain;
        redirects = this.account.staging.redirects || [];
      } else {
        this.domain = this.account.domain;
        redirects = this.account.redirects || [];
      }
			this.redirects = _.filter(redirects, item => item.uuid) || [];
		},
		mounted () {
			this.initDataTable();
		},
		methods: {
			store(redirect) {
				this.loading = true;
				let to = redirect.type + redirect.to;
				this.$http.post("redirect/create", {
					ip: this.account.ftp.host,
					domain: this.domain,
					grant_type: "token",
					token: this.userToken,
					source: redirect.from,
					target: to,
					code: redirect.code,
					uuid: redirect.uuid
				})
					.then((response) => {
						if (response.data.message === "1") {
							throw "Error created redirect";
						}
						redirect.uuid = response.data.message;
						this.redirects.push(redirect);
						this.initDataTable();
						this.save("Redirect was created")
							.finally(()=>{
								this.redirect = {};
								this.loading = false;
							});
					})
					.catch((err) => {
						let responseMessage = err.response.data.message;
						if (err.response.status === 422) {
							responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
						}else if(err.response.status === 401){
							responseMessage = "You need update token. Please Try Again!";
							this.refreshToken();
						}

						swal({
							title: "Something went wrong!",
							html: responseMessage,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
						/*
						if(err.response.status !== 401) {
							this.addLog({
								name: this.user.firstName + " " + this.user.lastName,
								message: `Error create redirect. Message: ${responseMessage}  Code: ${err.response.status}`,
								level: "danger"
							});
						}
						*/
						this.loading = false;
					});
			},
			update(redirect) {
				let to = redirect.type + redirect.to;
				this.$http.post('redirect/modify', {
					ip: this.account.ftp.host,
					domain: this.domain,
					grant_type: "token",
					token: this.userToken,
					source: redirect.from,
					target: to,
					code: redirect.code,
					uuid: redirect.uuid
				})
					.then((response) => {
						if (response.data.message == '1') {
							throw "Error modified redirect";
						}
						redirect.uuid = response.data.message;
						this.redirects = _.map(this.redirects, item => {
							if(item.uuid === redirect.uuid){
								return redirect;
							}
							return item;
						});
						// this.initDataTable();
						this.save("Redirect was modified");
					})
					.catch((err) => {
						let responseMessage = err.response.data.message;
						if (err.response.status === 422) {
							responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
						}else if(err.response.status === 401){
							responseMessage = "You need update token. Please Try Again!";
							this.refreshToken();
						}

						swal({
							title: "Something went wrong!",
							html: responseMessage,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
						/*
						this.addLog({
							name: this.user.firstName + " " + this.user.lastName,
							message: "Error modify redirect. Message: " + err.response.data.message,
							level: "danger"
						});
						*/
						this.itemChanged = !this.itemChanged;
					});
			},
			remove(redirect) {
				this.$http.post('redirect/delete', {
					ip: this.account.ftp.host,
					domain: this.domain,
					grant_type: "token",
					token: this.userToken,
					source: redirect.from,
					target: redirect.to,
					code: redirect.code,
					uuid: redirect.uuid
				})
					.then((response) => {
						if (response.data.message === '1') {
							throw "Error delete redirect";
						} else {
							this.redirects = _.filter(this.redirects, item => item.uuid !== redirect.uuid);
							this.initDataTable();
						}
						this.save("Redirect was deleted");
					})
					.catch((err) => {
						let responseMessage = err.response.data.message;
						if (err.response.status === 422) {
							responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
						}else if(err.response.status === 401){
							responseMessage = "You need update token. Please Try Again!";
							this.refreshToken();
						}

						swal({
							title: "Something went wrong!",
							html: responseMessage,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
						/*
						this.addLog({
							name: this.user.firstName + " " + this.user.lastName,
							message: "Error delete redirect. Message: " + err.response.data.message,
							level: "danger"
						});
						*/
						this.itemChanged = !this.itemChanged;
					});
			},
			importRedirects(event) {
				this.loading = true;
				this.file = this.$refs.file.files[0];
				let formData = new FormData();
				formData.append('importFile', this.file);
				formData.append('grant_type', "token");
				formData.append('token', this.userToken);
				formData.append('domain', this.domain);
				formData.append('ip', this.account.ftp.host);
				formData.append('uid', this.requestUserId);
				formData.append('firstName', this.user.firstName);
				formData.append('lastName', this.user.lastName);
				formData.append('email', this.user.email);

				this.$http(
					{
						method: 'post',
						url: '/redirect/queue_import',
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						data: formData
					}
				).then((response) => {
					console.log(response.data.msg);
					swal({
						title: "Success!",
						text: response.data.msg,
						type: "success",
					});
					// return
					// const errors = [];
					// const redirects = [];
					// const { data } = response.data;
					//
					// data.map((redirect)=>{
					// 	if(redirect.error !== undefined){
					// 		errors.push(`Error import redirect ${redirect.source} ${redirect.target} ${redirect.code}`);
					// 	}else{
					// 		let toUrlParse = uplParse(redirect.target);
					// 		redirects.push({
					// 			from: redirect.source,
					// 			to: toUrlParse.host + toUrlParse.pathname + toUrlParse.query,
					// 			code: redirect.code,
					// 			uuid: redirect.uuid,
					// 			type: toUrlParse.protocol + (toUrlParse.slashes ? '//' : '')
					// 		});
					// 	}
					// });
					//
					// if(errors.length > 0){
					// 	swal({
					// 		title: "Something went wrong!",
					// 		html: errors.join(", "),
					// 		type: "error",
					// 	});
					// } else {
					// 	this.redirects = _.concat(this.redirects, redirects);
					// 	this.save("Redirects was imported");
					// }
				})
					.catch((err) => {

						let responseMessage = err.response.data.message;
						if (err.response.status === 422) {
							responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
						}else if(err.response.status === 401){
							responseMessage = "You need update token. Please Try Again!";
							this.refreshToken();
						}

						swal({
							title: "Something went wrong!",
							html: responseMessage,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
						this.addLog({
							name: this.user.firstName + " " + this.user.lastName,
							message: "Error import redirects. Message: " + err.response.data.message,
							level: "danger"
						});
					})
					.finally(() => {
						event.target.value = '';
						this.file = null;
						this.loading = false;
					});
			},
			save(message) {
				let accounts = this.accounts;
				accounts = accounts.map((account) => {
					if (this.account.type === 'Addon Domain') {
						let addons = account.addon;
						addons = _.map(addons, (addon) => {
							if (addon.domain === this.domain) {
								if (this.envType === 'staging') {
									addon.staging.redirects = this.redirects;
								} else {
									addon.redirects = this.redirects;
								}
							}
							return addon;
						});
						account.addon = addons;
					} else {
						let primary = account.primary;
						if (this.envType === 'staging') {
							primary.staging.redirects = this.redirects;
						} else {
							primary.redirects = this.redirects;
						}
						account.primary = primary;
					}
					return account;
				});
				return this.saveToDb(accounts, message);
			},
			saveToDb(accounts, message) {
				return db
					.collection("hostingAccounts")
					.doc(this.requestUserId)
					.set({
						accounts: accounts
					})
					.then(() => {
						swal({
							title: "Success!",
							html: message,
							type: "success"
						});
						this.addLog({
							name: this.user.firstName + " " + this.user.lastName,
							message: message,
							level: "info"
						});
					})
					.finally(()=>{
						this.itemChanged = !this.itemChanged;
					});
			},
			initDataTable () {
				/* eslint-disable */
				$(".redirect-table").DataTable().destroy();
				$(document).ready( () => {
					$(".redirect-table").DataTable({
						ordering: false,
						deferRender: true,
						language: {
							search: "_INPUT_",
							searchPlaceholder: "Search Redirects",
							emptyTable: "No redirect exists for domain: " + this.domain,
							size: '40'
						}
					});
				});
				$(".redirect-table th").removeClass('sorting_asc');
				/* eslint-enable */
			}
		}
	};
</script>
